/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Group_OperateInputs */

const en_directory_agent_readiness_group_operate = /** @type {(inputs: Directory_Agent_Readiness_Group_OperateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operate`)
};

const zh_directory_agent_readiness_group_operate = /** @type {(inputs: Directory_Agent_Readiness_Group_OperateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`执行工作流`)
};

/**
* | output |
* | --- |
* | "Operate" |
*
* @param {Directory_Agent_Readiness_Group_OperateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_group_operate = /** @type {((inputs?: Directory_Agent_Readiness_Group_OperateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Group_OperateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_group_operate(inputs)
	return zh_directory_agent_readiness_group_operate(inputs)
});
export { directory_agent_readiness_group_operate as "directory.agent_readiness.group.operate" }